import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {AuthRouter} from './AuthRouter';
import {getLegacyRedirectUrl} from './getLegacyRedirectUrl';
import {
  getGrowthbook,
  initialiseCoreLibraries,
} from '../initialise-core-libraries';
import {GrowthBookProvider} from '@growthbook/growthbook-react';
import {
  DeviceProvider,
  setErrorCatcher,
  ToastPortal,
  ToastProvider,
} from '@treatwell/ui';
import {EnvConfigContextProvider} from '../config';
import {ErrorBoundary, GenericErrorPage} from '../components/Error';
import '../styles/app.css';
import {errorCatcher} from '../../shared/utils/errorCatcher';
import {whenWafBotControlReady} from '../whenWafBotControlReady';

whenWafBotControlReady(() => {
  initialiseCoreLibraries();
  setErrorCatcher({errorCatcher: errorCatcher});
  renderApp();
});

async function renderApp() {
  const appRoot = 'app';
  const container = document.getElementById(appRoot);

  if (!container) {
    throw new Error('Failed to find the root element');
  }

  const root = createRoot(container);
  const growthbook = await getGrowthbook();

  const legacyRedirectUrl = getLegacyRedirectUrl(growthbook, window.location);

  if (legacyRedirectUrl) {
    window.location.href = legacyRedirectUrl;
    return;
  }

  root.render(
    <StrictMode>
      <ErrorBoundary errorComponent={<GenericErrorPage />}>
        <DeviceProvider userAgent={navigator.userAgent}>
          <GrowthBookProvider growthbook={growthbook}>
            <EnvConfigContextProvider>
              <ToastProvider>
                <AuthRouter />
                <ToastPortal root={appRoot} />
              </ToastProvider>
            </EnvConfigContextProvider>
          </GrowthBookProvider>
        </DeviceProvider>
      </ErrorBoundary>
    </StrictMode>
  );
}
